import { Banner, FlexBox, Text } from '@dixa/lib-shared-habla';

import { articles } from 'utils/elevio';

export const ScheduledConversationsBanner = (): JSX.Element => {
  return (
    <FlexBox flex="0">
      <Banner
        variant="info"
        description={
          <Text.Paragraph as="span" variant="4">
            After importing the .csv file, Dixa will automatically offer the
            conversations to the selected queue on the selected date. You can
            find more information in the{' '}
            <span
              role="button"
              data-elevio-article={
                articles.settings.scheduledConversations.documentation
              }
              data-elevio-style="nothing"
              style={{ textDecoration: 'underline' }}
            >
              documentation.
            </span>
          </Text.Paragraph>
        }
      />
    </FlexBox>
  );
};
